import * as React from 'react';
import Project from 'src/entities/Project';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';
import ImageContainer from 'src/modules/commons/images/Image.container';
import HtmlFormater from 'src/utils/htmlFormaterUtil';

interface Props {
  project: Project;
  isLogged: boolean;
  invest: boolean;
  closedProject: boolean;
}

class ProjectSummaryComponent extends React.PureComponent<Props> {

  render() {
    return (
      <div className="col-sm-9">
        <div className="padding-left-30">
          <div className="gap-50"/>

          <h3>
            Resumen de la compañía
          </h3>
          <div className="gap-20"/>
          <div className="row">
            <div className="col-sm-6">
              <div
                className="from-rich-editor"
                dangerouslySetInnerHTML={{__html: HtmlFormater.parseMarkDownImages(this.props.project.description)}}
              />
            </div>
            <div className="col-sm-6">
              <div
                id="myCarousel"
                className="carousel slide"
                data-ride="carousel"
              >
                <div className="carousel-inner">
                  {
                    this.props.project.images.map((image, key) => (
                      <div
                        className={'item ' + (key === 0 ? 'active' : '')}
                        key={image.id}
                      >
                        <ImageContainer
                          style={{margin: '0 auto', height: '200px'}}
                          url={image.url}
                        />
                        <img
                        />
                        <div className="carousel-caption d-none d-md-block">
                          <p className="f-s-12 c-black-text">
                            <strong>{key + 1}</strong> /&nbsp;
                            <span className="c-grey">{this.props.project.images.length}</span>
                          </p>
                        </div>
                      </div>
                    ))
                  }
                </div>
                <div className="row project-carousel-indicators">
                  <div className="col-xs-10">
                    <ol className="carousel-indicators">
                      {
                        this.props.project.images.map((image, key) => (
                          <li
                            key={key}
                            data-target="#myCarousel"
                            data-slide-to={key}
                            className={key === 0 ? 'active' : ''}
                          />
                        ))
                      }
                    </ol>
                  </div>
                  <div className="col-xs-2 text-right">

                    <a
                      className="left carousel-control"
                      href="#myCarousel"
                      data-slide="prev"
                    >
                      <span className="arrow-right-grey arrow-left-black"/>
                      <span className="sr-only">
                    Previous
                  </span>
                    </a>
                    <a
                      className="right carousel-control"
                      href="#myCarousel"
                      data-slide="next"
                    >
                      <span className="arrow-right-grey arrow-right-black"/>
                      <span className="sr-only">
                    Next
                  </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="gap-50"/>
          <ProjectActionToolbarContainer
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.props.closedProject}
          />
          <div className="gap-50"/>
        </div>
      </div>
    );
  }
}

export default ProjectSummaryComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/ProjectSummary.component.tsx